<!-- This File shows the account details for a Seller -->
<template>
  <div class="sitesettings">
     <h1> Site Settings </h1>

     <div class="ml-4 text-xs-left" >
       <br /><br />

       <!-- Site Name -->
       <SiteNameCard></SiteNameCard>

       <!-- Social Media Selector -->
       <SocialMediaSettings></SocialMediaSettings>

       <CreditCardSettings></CreditCardSettings>

       <PaymentInPersonSettings></PaymentInPersonSettings>
       <DeliverySettings></DeliverySettings>
       <ThemeSettings></ThemeSettings>
       <TaxSettings></TaxSettings>

       <ReturnToDashboard></ReturnToDashboard>
    </div>

</div>

</template>

<script>

import {mapState} from 'vuex'
import SiteNameCard from './sitesettings/SiteNameCard'
import SocialMediaSettings from './sitesettings/SocialMediaSettings'
import CreditCardSettings from './sitesettings/CreditCardSettings'
import PaymentInPersonSettings from './sitesettings/PaymentInPersonSettings'
import DeliverySettings from './sitesettings/DeliverySettings'
import ThemeSettings from './sitesettings/ThemeSettings'
import TaxSettings from './sitesettings/TaxSettings'
import ReturnToDashboard from './ReturnToDashboard'

export default {
  name: 'SiteSettings',
  components: {
    SiteNameCard,
    SocialMediaSettings,
    CreditCardSettings,
    PaymentInPersonSettings,
    DeliverySettings,
    ThemeSettings,
    TaxSettings,
    ReturnToDashboard
  },
  computed: {
    ...mapState({
      name: state => state.admin.userInfo.name,
      subscriptionStatus: state => state.admin.data_ro.subscriptionStatus
    })

  },
  props: {

  },
  data () {
    return {
    }
  },

  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
